import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportAverageTotalsRequestDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-totals-average.request.dto';
import { AccountSentimentReportAverageTotalsAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-average-totals.aggregate-root';
import { GetAccountSentimentReportAverageTotalsApplicationService } from '../../../core/application/services/sentiment/get-account-sentiment-report-average-totals.application-service';

export class GetAccountSentimentReportAverageTotalsMetricsQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountSentimentReportAverageTotalsApplicationService
  ) {}
  async execute(
    props: GetAccountSentimentReportAverageTotalsRequestDto
  ): Promise<AccountSentimentReportAverageTotalsAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
